import React from 'react';
import {ViewProps} from './model';
import {GetDesktopTableStyles} from './styles';
import {StyleSheet, View} from 'react-native';
import {Table} from '../../../../../shared/components/table';
import {Column} from '../../../../../shared/components/table/model';
import {Text} from '../../../../../shared/components/text';
import {format} from 'date-fns';
import {dateFormats} from '../../../../../shared/constants/date';
//TODO Change name and check internals of molodayaArticaResponsePayload
import {MolodayaArcticaItem, WithdrawSource} from '../../../../../shared/models/api/molodayaArticaResponsePayload';
import {Link} from '../../../../../shared/components/link';

export const DesktopView = ({data}: ViewProps) => {
  const styles = GetDesktopTableStyles();
  const columns: Column<MolodayaArcticaItem>[] = [
    {
      title: 'Наименование операции',
      render: (item) => (
        <Text type='h6Light'>
          {item.withdrawSource === WithdrawSource.Arctica
            ? item.products.map((p) => `${p.title} x${p.count}`)
            : 'Обмен баллов'}
        </Text>
      ),
      field: 'name',
      headStyles: {
        colHeadStyle: {...StyleSheet.flatten(styles.headCell), ...StyleSheet.flatten(styles.colDescription)},
      },
      styles: {
        colBodyStyle: {...StyleSheet.flatten(styles.cell), ...StyleSheet.flatten(styles.colDescription)},
      },
    },
    {
      title: 'Кол-во баллов',
      render: (item) => <Text type='h6Light'>{item.score > 0 ? item.score : ''}</Text>,
      field: 'score',
      headStyles: {
        colHeadStyle: {...StyleSheet.flatten(styles.headCell), ...StyleSheet.flatten(styles.colAmount)},
      },
      styles: {
        colBodyStyle: {...StyleSheet.flatten(styles.cell), ...StyleSheet.flatten(styles.colAmount)},
      },
    },
    {
      title: 'Дата',
      render: (item) => <Text type='h6Light'>{format(new Date(item.date), dateFormats.fullDate)}</Text>,
      field: 'date',
      headStyles: {
        colHeadStyle: {...StyleSheet.flatten(styles.headCell), ...StyleSheet.flatten(styles.colDate)},
      },
      styles: {
        colBodyStyle: {...StyleSheet.flatten(styles.cell), ...StyleSheet.flatten(styles.colDate)},
      },
    },
  ];

  return (
    <View style={styles.container}>
      {data?.length ? (
        <Table data={data} columns={columns} testIdPrefix='history-table' />
      ) : (
        <View>
          <Text style={styles.noData}>Нет данных</Text>
          <Link
            textStyle={styles.link}
            external
            href='https://xn----7sbbaq1anbcjwb4a3a4q.xn--p1ai/profile/points'
            testID='go-to-profile-points'>
            Подключить учетную запись ЕКЖ в Молодой Арктике
          </Link>
        </View>
      )}
    </View>
  );
};
